
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { AuditDocumentsAPI } from "api/api/auditDocumentsApi/auditDocumentsApi";
import { DeleteAuditDocumentParams, DeleteAuditDocumentResponse } from "api/api/auditDocumentsApi/types";

export const deleteAuditDocument = createAsyncThunk<
  DeleteAuditDocumentResponse,
  DeleteAuditDocumentParams
>("documents/deleteAuditDocument", async (params, { rejectWithValue }) => {
  try {
    const data = await AuditDocumentsAPI.deleteAuditDocument(params);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error(
        "Error while deleting audit-document",
        error.response?.data
      );
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while deleting audit-document", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
